import { createContext, useState, useEffect } from "react";

export const UnitShadeContext = createContext();

export const UnitShadeProvider = ({ children }) => {
  // Load from localStorage once
  const [unitShadeNo, setUnitShadeNo] = useState(() => {
    const saved = localStorage.getItem("unitShade");
    return saved ? Number(saved) : 0;
  });

  // Save to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("unitShade", unitShadeNo);
  }, [unitShadeNo]);

  return (
    <UnitShadeContext.Provider value={{ unitShadeNo, setUnitShadeNo }}>
      {children}
    </UnitShadeContext.Provider>
  );
};